// extracted by mini-css-extract-plugin
module.exports = {"select":"select__2QvQo","label":"label__3FGvo","text":"text__1kc72","body":"body__28o-E"};